import { useEffect } from "react";

export function usePreloadImages(imageList, basePath) {
  useEffect(() => {
    imageList.forEach((image) => {
      const img = new window.Image();
      img.src = `${basePath}/${image}`;
    });
  }, [imageList, basePath]);
}
